import { CONSTANT } from '../../../constant/constant';
import { ENDPOINTS } from '../../../constant/endpoints';
import {
    generalHttpGetRequest,
    generalHttpPutRequest
} from '../../../helper/request-helper';

const pendingTrustsUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.security.pendingTrusts;
const pendingPortfoliosUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.security.pendingPortfolios;
const pendingClassesUrl =
    CONSTANT.baseUrl + ENDPOINTS.employee.security.pendingClasses;

export const actionType = {
    REQUESTED_SECURITY_DATA: 'REQUESTED_SECURITY_DATA',
    REJECTED_SECURITY_DATA: 'REJECTED_SECURITY_DATA',
    UPDATE_PENDING_TRUST: 'UPDATE_PENDING_TRUST',
    FETCH_PENDING_TRUSTS: 'FETCH_PENDING_TRUSTS',
    UPDATE_EDIT_PENDING_TRUST_PAYLOAD: 'UPDATE_EDIT_PENDING_TRUST_PAYLOAD',
    UPDATE_PENDING_PORTFOLIO: 'UPDATE_PENDING_PORTFOLIO',
    FETCH_PENDING_PORTFOLIOS: 'FETCH_PENDING_PORTFOLIOS',
    UPDATE_EDIT_PENDING_PORTFOLIO_PAYLOAD:
        'UPDATE_EDIT_PENDING_PORTFOLIO_PAYLOAD',
    UPDATE_PENDING_CLASS: 'UPDATE_PENDING_CLASS',
    FETCH_PENDING_CLASSES: 'FETCH_PENDING_CLASSES',
    UPDATE_EDIT_PENDING_CLASS_PAYLOAD: 'UPDATE_EDIT_PENDING_CLASS_PAYLOAD'
};

export const fetchPendingTrusts = () => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_SECURITY_DATA
        });

        return generalHttpGetRequest(pendingTrustsUrl)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_PENDING_TRUSTS,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_SECURITY_DATA,
                    data: error
                });
            });
    };
};

export const updatePendingTrust = (trustId, payload) => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_SECURITY_DATA
        });

        return generalHttpPutRequest(pendingTrustsUrl + trustId, payload)
            .then(response => {
                dispatch({
                    type: actionType.UPDATE_PENDING_TRUST,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_SECURITY_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const updateEditPendingTrustPayload = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_EDIT_PENDING_TRUST_PAYLOAD,
            payload: selected
        });
    };
};

export const fetchPendingPortfolios = () => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_SECURITY_DATA
        });

        return generalHttpGetRequest(pendingPortfoliosUrl)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_PENDING_PORTFOLIOS,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_SECURITY_DATA,
                    data: error
                });
            });
    };
};

export const updatePendingPortfolio = (portfolioId, payload) => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_SECURITY_DATA
        });

        return generalHttpPutRequest(
            pendingPortfoliosUrl + portfolioId,
            payload
        )
            .then(response => {
                dispatch({
                    type: actionType.UPDATE_PENDING_PORTFOLIO,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_SECURITY_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const updateEditPendingPortfolioPayload = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_EDIT_PENDING_PORTFOLIO_PAYLOAD,
            payload: selected
        });
    };
};

export const fetchPendingClasses = () => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_SECURITY_DATA
        });

        return generalHttpGetRequest(pendingClassesUrl)
            .then(response => {
                dispatch({
                    type: actionType.FETCH_PENDING_CLASSES,
                    payload: response.data
                });
                return response.data;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_SECURITY_DATA,
                    data: error
                });
            });
    };
};

export const updatePendingClass = (classId, payload) => {
    return dispatch => {
        dispatch({
            type: actionType.REQUESTED_SECURITY_DATA
        });

        return generalHttpPutRequest(pendingClassesUrl + classId, payload)
            .then(response => {
                dispatch({
                    type: actionType.UPDATE_PENDING_CLASS,
                    payload: response.data
                });
                return response;
            })
            .catch(error => {
                dispatch({
                    type: actionType.REJECTED_SECURITY_DATA,
                    data: error
                });
                return error;
            });
    };
};

export const updateEditPendingClassPayload = selected => {
    return dispatch => {
        return dispatch({
            type: actionType.UPDATE_EDIT_PENDING_CLASS_PAYLOAD,
            payload: selected
        });
    };
};




// WEBPACK FOOTER //
// ./src/services/redux/employee/security/actions.js